import { SimplePage } from "@/app/_/marketing/SimplePage";
import { HotkeysFeature } from "@/app/_/sections/3FeaturesSection/HotkeysFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="For small businesses"
      title="Financial clarity without the complexity."
      subtitle="Bank sync, transaction triage, customizable reports, and agent-assisted workflows — so you spend time on the business, not wrangling the books."
      secondaryCta={{
        label: "Book a demo",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "triage-reconcile",
        alt: "This week's transactions, ready to confirm",
      }}
      capabilities={[
        {
          title: "Your bank, already sorted.",
          description:
            "Transactions sync in and line up in one list, with the supplier and category filled in where Neoledger is sure.",
          imageName: "crop-triage-list",
        },
        {
          title: "Ten minutes, not a weekend.",
          description:
            "Confirm what's right with a keystroke, fix what isn't, and move on. The queue remembers your choices.",
          imageName: "crop-command-palette",
        },
        {
          title: "Know where the money went.",
          description:
            "A dashboard of income, expenses, and cash that's always current — no accountant needed to read it.",
          imageName: "crop-report-widgets",
        },
      ]}
      illustration={{
        title: "Fast by default.",
        description:
          "Every action is a shortcut away, so keeping the books current fits between customers.",
        render: () => HotkeysFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/triage", "/platform/ledger"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
